<template>
  <div v-if="loading">
    <OurCard v-for="card in cardsCount" :key="card" class="mb-4">
      <div class="grid grid-cols-[64px_1fr] gap-4">
        <div
          v-for="item in tableHeaders"
          :key="item.value"
          :class="item.value !== 'name' && item.value !== 'image' ? 'col-span-2' : ''"
        >
          <SkeletonLoader :type="item.value" />
        </div>
      </div>
    </OurCard>
  </div>
  <div v-else>{{ $t("page.dashboard.emptyMessage") }}</div>
</template>

<script>
import SkeletonLoader from "@/ui/loader/SkeletonLoader";
import { mapGetters } from "vuex";
export default {
  name: "SkeletonLoaderCard",
  components: { SkeletonLoader },
  props: {
    tableHeaders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cardsCount: 3,
    };
  },
  computed: {
    ...mapGetters("loaderTop", ["loading"]),
  },
};
</script>
